import React from 'react'
import PropTypes from 'prop-types'
import { SessionStore } from '../../stores'
import { inject, observer } from 'mobx-react'

@inject('sessionStore')
@observer
class SessionTimeoutModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      modalTimer: undefined,
      timeout: false,
      timeoutCount: 0,
      timeoutLimit: 20, // 20 seconds
      show: false
    }

    this.sessionTimeoutModalRef = React.createRef()

    this.show = this.show.bind(this)
    this.close = this.close.bind(this)

    this.onShow = this.onShow.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  componentDidMount () {
    if (typeof this.state.modalTimer !== 'undefined') {
      clearInterval(this.state.modalTimer)
    }

    const newTimer = setInterval(() => {
      if (this.state.show) {
        this.setState({ timeoutCount: this.state.timeoutCount + 1 })
      }

      if (this.state.timeoutCount === this.state.timeoutLimit) {
        // automatically time out
        this.setState({
          timeout: true
        }, () => {
          this.close()
        })
      }
    }, 1000)

    this.setState({ modalTimer: newTimer })

    this.sessionTimeoutModalRef.current.addEventListener('show', (e) => this.onShow())
    this.sessionTimeoutModalRef.current.addEventListener('close', (e) => this.onClose(e.detail.value))
  }

  componentWillUnmount () {
    if (typeof this.state.modalTimer !== 'undefined') {
      clearInterval(this.state.modalTimer)
    }
  }

  show () {
    this.sessionTimeoutModalRef.current.show()
  }

  close () {
    this.sessionTimeoutModalRef.current.close()
  }

  onShow () {
    this.setState({
      show: true,
      timeoutCount: 0,
      modalTimer: undefined
    })
  }

  onClose (stayLoggedIn) {
    this.setState({
      show: false,
      timeoutCount: 0,
      modalTimer: undefined
    }, () => {
      switch (stayLoggedIn) {
        case true:
          this.props.resetIdle()
          break
        case false:
          if (this.state.timeout) {
            this.props.handleTimeout()
          } else {
            this.props.handleLogout()
          }
          break
      }
    })
  }

  render () {
    return (
      <mosaic-dialog ref={this.sessionTimeoutModalRef} color='warning'
        type='warning' header-title='Are you still there?' id='inactivity-dialog' confirm-text='Stay logged in' dismiss-text='Log out now'>
        <p>For your security, sessions expire automatically after 15 minutes of inactivity.</p>
        <p>Your current session will expire in {this.state.timeoutLimit - this.state.timeoutCount} seconds.</p>
      </mosaic-dialog>
    )
  }
}

SessionTimeoutModal.propTypes = {
  sessionStore: PropTypes.instanceOf(SessionStore),
  handleLogout: PropTypes.func,
  handleTimeout: PropTypes.func,
  resetIdle: PropTypes.func
}

export { SessionTimeoutModal }
